import { Button, makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles(({ palette, ...theme }) => ({
  btnStyles: {
    background: palette.btn.main,
    color: "#fff",
    fontSize: "1.1rem",
    height: "100%",
    width: "151px",
    textTransform: "capitalize",
    "&:hover": {
      background: palette.btn.main,
      opacity: 0.8,
    },
  },
}));
function DefaultButton({ label, ...props }) {
  const classes = useStyles();
  return (
    <Button variant="contained" className={classes.btnStyles} {...props}>
      {label}
    </Button>
  );
}

export default DefaultButton;
